<div class="flex justify-between items-center gap-2 text-{{size}}">
    <p class="font-light {{colorTitle}}">{{title}}</p>
    <p class="font-semibold {{colorValue}}">{{value}}</p>
</div>